import { ChildrenStoreData } from 'src/shared/types/src';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { MyWorldActions } from './MyWorldSlice';
import { fetchMyWorldDetailAPI } from 'src/shared/services/src';

export const fetchMyWorldData = createAsyncThunk(
  'fetchMyWorldData',
  async ({ child }: { child: ChildrenStoreData }, { dispatch }) => {
    try {
      await dispatch(MyWorldActions.setMyWorldLoading(true));
      const response = await fetchMyWorldDetailAPI({ child });
      if (response && Object.keys(response).length > 0 && response.data)
        await dispatch(MyWorldActions.setMyWorldDetails(response.data));
    } catch (error: any) {
      console.log('error in timeline api : ', error.response);
    } finally {
      dispatch(MyWorldActions.setMyWorldLoading(false));
    }
  }
);
